import React, { useEffect, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, StarIcon, Quote } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'Sarah Johnson',
  location: 'Naples, FL',
  text: 'Air-Mazing Air was incredible! They replaced our AC system quickly and professionally. The technicians were knowledgeable and took the time to explain everything. Our home has never been more comfortable!',
  rating: 5,
  image: 'https://randomuser.me/api/portraits/women/44.jpg'
}, {
  id: 2,
  name: 'Michael Rodriguez',
  location: 'Fort Myers, FL',
  text: 'I called for an emergency repair on a Sunday afternoon, and they were at my door within two hours. Fixed the problem quickly and charged a fair price with no weekend upcharge. Highly recommend!',
  rating: 5,
  image: 'https://randomuser.me/api/portraits/men/32.jpg'
}, {
  id: 3,
  name: 'Jennifer Wilson',
  location: 'Cape Coral, FL',
  text: "We've been using Air-Mazing for all our HVAC needs for the past 3 years. Their maintenance plan has saved us so much money by preventing major issues. The technicians are always professional and courteous.",
  rating: 5,
  image: 'https://randomuser.me/api/portraits/women/68.jpg'
}, {
  id: 4,
  name: 'David Thompson',
  location: 'Bonita Springs, FL',
  text: "After getting quotes from several companies, Air-Mazing offered the best value for our new system. The installation was flawless, and they even helped us apply for rebates we didn't know about!",
  rating: 5,
  image: 'https://randomuser.me/api/portraits/men/75.jpg'
}, {
  id: 5,
  name: 'Lisa Martinez',
  location: 'Estero, FL',
  text: 'The air quality in our home has improved dramatically since Air-Mazing installed our new filtration system. My allergies have decreased significantly, and the whole family is breathing easier.',
  rating: 5,
  image: 'https://randomuser.me/api/portraits/women/90.jpg'
}];
export const TestimonialsSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAutoplay, setIsAutoplay] = useState(true);
  useEffect(() => {
    if (!isAutoplay) return;
    const interval = setInterval(() => {
      setActiveIndex(current => (current + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [isAutoplay]);
  const handlePrev = () => {
    setIsAutoplay(false);
    setActiveIndex(current => (current - 1 + testimonials.length) % testimonials.length);
  };
  const handleNext = () => {
    setIsAutoplay(false);
    setActiveIndex(current => (current + 1) % testimonials.length);
  };
  const goToSlide = index => {
    setIsAutoplay(false);
    setActiveIndex(index);
  };
  return <section className="py-16 bg-gradient-to-b from-white to-blue-50" data-id="element-345">
      <div className="container mx-auto px-4" data-id="element-346">
        <div className="text-center mb-12" data-id="element-347">
          <span className="inline-block px-4 py-1.5 rounded-full bg-blue-100 text-blue-700 font-semibold text-sm mb-4" data-id="element-348">
            TESTIMONIALS
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-5" data-id="element-349">
            What Our Customers Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-350">
            Don't just take our word for it. Here's what our satisfied customers
            have to say about our services.
          </p>
        </div>
        <div className="relative max-w-5xl mx-auto" data-id="element-351">
          {/* Testimonial Cards */}
          <div className="overflow-hidden" data-id="element-352">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${activeIndex * 100}%)`
          }} data-id="element-353">
              {testimonials.map(testimonial => <div key={testimonial.id} className="w-full flex-shrink-0 px-4" data-id="element-354">
                  <div className="bg-white rounded-2xl shadow-xl p-8 border-t-4 border-blue-500 h-full" data-id="element-355">
                    <div className="flex flex-col md:flex-row md:items-center mb-6" data-id="element-356">
                      <div className="flex-shrink-0 mb-4 md:mb-0 md:mr-6" data-id="element-357">
                        <img src={testimonial.image} alt={testimonial.name} className="w-16 h-16 rounded-full object-cover border-2 border-blue-100" data-id="element-358" />
                      </div>
                      <div data-id="element-359">
                        <h3 className="text-xl font-bold text-gray-800" data-id="element-360">
                          {testimonial.name}
                        </h3>
                        <p className="text-gray-600" data-id="element-361">{testimonial.location}</p>
                        <div className="flex mt-1" data-id="element-362">
                          {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-4 w-4 ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`} fill={i < testimonial.rating ? 'currentColor' : 'none'} data-id="element-363" />)}
                        </div>
                      </div>
                    </div>
                    <div className="relative" data-id="element-364">
                      <Quote className="absolute -top-2 -left-2 h-8 w-8 text-blue-200 transform rotate-180" data-id="element-365" />
                      <p className="text-gray-600 leading-relaxed pl-6" data-id="element-366">
                        {testimonial.text}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
          {/* Navigation Buttons */}
          <button onClick={handlePrev} className="absolute top-1/2 left-0 md:-left-12 transform -translate-y-1/2 bg-white p-3 rounded-full shadow-md hover:shadow-lg transition-all duration-300 hover:bg-gray-50 focus:outline-none" aria-label="Previous testimonial" data-id="element-367">
            <ChevronLeftIcon className="h-6 w-6 text-blue-600" data-id="element-368" />
          </button>
          <button onClick={handleNext} className="absolute top-1/2 right-0 md:-right-12 transform -translate-y-1/2 bg-white p-3 rounded-full shadow-md hover:shadow-lg transition-all duration-300 hover:bg-gray-50 focus:outline-none" aria-label="Next testimonial" data-id="element-369">
            <ChevronRightIcon className="h-6 w-6 text-blue-600" data-id="element-370" />
          </button>
          {/* Dots Indicator */}
          <div className="flex justify-center mt-8 space-x-2" data-id="element-371">
            {testimonials.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${index === activeIndex ? 'bg-blue-600 w-6' : 'bg-gray-300 hover:bg-blue-400'}`} aria-label={`Go to testimonial ${index + 1}`} data-id="element-372" />)}
          </div>
        </div>
      </div>
    </section>;
};